import { Controller } from "@hotwired/stimulus";
import { useClickOutside } from "stimulus-use";
import { computePosition, autoPlacement } from "@floating-ui/dom";
import { auto } from "@cloudinary/url-gen/qualifiers/quality";

export default class extends Controller {
  static values = { text: String, placement: String };

  connect() {
    this.element.addEventListener("mouseenter", this.show.bind(this));
    this.element.addEventListener("mouseleave", this.hide.bind(this));
  }

  disconnect() {
    this.element.removeEventListener("mouseenter", this.show.bind(this));
    this.element.removeEventListener("mouseleave", this.hide.bind(this));
  }

  async show(event) {
    event.preventDefault();

    this.content = document.createElement("div");
    const innerTooltip = document.createElement("div");
    innerTooltip.classList.add(
      "tooltip",
      "max-w-lg",
      "whitespace-normal",
      "break-words"
    );
    innerTooltip.textContent = this.textValue;
    this.content.appendChild(innerTooltip);
    this.content.classList.add(
      "absolute",
      "p-1",
      "z-50",
      "pointer-events-none"
    );

    let anchor = this.element;
    anchor.appendChild(this.content);

    computePosition(anchor, this.content, {
      placement: this.placementValue || "bottom-start",
      // middleware: [autoPlacement()],
    }).then(({ x, y }) => {
      Object.assign(this.content.style, {
        left: `${x}px`,
        top: `${y}px`,
      });
    });
    console.log("show");
  }

  hide() {
    if (this.content) {
      this.content.remove();
      this.content = null;
    }
  }
}
